export enum VehicleStatus {
  ENABLED = "ENABLED",
  DISABLED = "DISABLED",
}

export class Vehicle {
  vehicle_id: string;
  eva_company_id: string;
  corporate_id: string;
  license_plate: string;
  status: VehicleStatus = VehicleStatus.ENABLED;
  drivers_ids: string[] = [];

  constructor() {
    this.status = VehicleStatus.ENABLED;
  }

  public static createInstance(jsonData: Vehicle): Vehicle {
    const c = Object.assign(new Vehicle(), jsonData);

    return c;
  }

  public static createInstances(jsonData: Vehicle[]): Vehicle[] {
    return jsonData.map(Vehicle.createInstance);
  }
}
